import { Badge, Col, Row } from "antd";

import React, { useEffect, useState } from "react";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import Typography from "../components/Typography";
import { COLORS } from "../constants/Colors";
import SearchCardWithFilter from "../components/SearchCardWithFilter";
import ShipmentList from "../components/ParkingList";
import { instance } from "../components/AxiosClient";
import GetProfile from "../components/VariableStore";
import { useDebounce } from "../utils/hooks/useDebounce";
import _ from "lodash";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import FilterTracking from "../components/FilterTracking";
import moment from "moment";
import {
  errorNotification,
  successNotification,
} from "../components/Notification";
import { useIsMoblie, useIsTablet } from "../utils/hooks/useMobile";
import {
  getContractPaging,
  getQueueuList,
  getQueueuStatus,
} from "../controllers/home/CardHomeAPI";
import ParkingList from "../components/ParkingList";

const CheckingStatusPark = () => {
  const intl = useIntl();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMoblie();
  const state = useSelector((state) => state);
  const [shipmentData, setShipmentData] = useState([]);
  const [queueSearch, setQueueSearch] = useState();
  const [pagination, setPagination] = useState(1);
  const [total, setTotal] = useState();
  const useDebounceSearch = useDebounce(queueSearch, 500);
  const parsLocal = JSON.parse(localStorage.getItem("persist:loop_store"));
  const customerData = JSON.parse(parsLocal.customerProfileReducer);
  const [event, setEvent] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDot, setFilterDot] = useState(false);
  const [parkingStatus, setParkingStatus] = useState([]);
  const [queueuFilter, setQueueFilter] = useState({
    queueStatus: undefined,
    fromCreateDateIn: undefined,
    toCreateDateIn: undefined,
    fromCreateDateOut: undefined,
    toCreateDateOut: undefined,
  });

  const [searchTable, setSearchTable] = useState({
    order: undefined,
    field: undefined,
    page: 1,
    size: "10",
  });

  const [queueList, setQueueList] = useState([]);

  const comCode = GetProfile("customerCode") || _.get(customerData, "comCode");
  const customerId =
    GetProfile("customerId") || _.get(customerData, "customerId");

  console.log("parsLocal", queueuFilter, queueSearch);

  useEffect(() => {
    const getQueueList = async () => {
      const body = {
        customerId: customerId,
        searchCarLot: queueSearch,
        type: "carLot",
        pageNumber: _.get(searchTable, "page"),
        limit: parseInt(_.get(searchTable, "size")),
        status: _.get(queueuFilter, "queueStatus")
          ? _.get(queueuFilter, "queueStatus")
          : "",
        startFilterStartDate: _.get(queueuFilter, "fromCreateDateIn")
          ? moment(_.get(queueuFilter, "fromCreateDateIn")).format("DD-MM-YYYY")
          : undefined,
        startFilterEndDate: _.get(queueuFilter, "toCreateDateIn")
          ? moment(_.get(queueuFilter, "toCreateDateIn")).format("DD-MM-YYYY")
          : undefined,
        endFilterStartDate: _.get(queueuFilter, "fromCreateDateOut")
          ? moment(_.get(queueuFilter, "fromCreateDateOut")).format(
              "DD-MM-YYYY"
            )
          : undefined,
        endFilterEndDate: _.get(queueuFilter, "toCreateDateOut")
          ? moment(_.get(queueuFilter, "toCreateDateOut")).format("DD-MM-YYYY")
          : undefined,

        orderBy: _.get(searchTable, "field"),
        order: _.get(searchTable, "order"),

        // searchCarLot: useDebounceSearch,
      };

      try {
        const response = await getContractPaging(body);
        const status = await getQueueuStatus();
        setParkingStatus(status);
        setQueueList(response.data.contractList);
        setTotal(response.data.totalItem);
      } catch (error) {}
    };
    getQueueList();
  }, [event, useDebounceSearch, searchTable]);

  useEffect(() => {
    if (comCode && customerId) {
      // getOrdersList();
    }
  }, [
    useDebounceSearch,
    comCode,
    customerId,
    pagination,
    event,
    state.globalReducer.triggerOrder,
  ]);

  const handleSerchQueue = (values) => {
    setQueueSearch(values);
  };

  const handleFilterShipment = (values, key) => {
    // console.log('orderStatus',moment(new Date(values)).format('YYYY-MM-DD'),'/key:',values);

    if (values === "" || values === undefined || values === null) {
      setFilterDot(false);
    } else {
      setFilterDot(true);
    }
    if (key === "queueStatus") {
      setQueueFilter((prev) => ({ ...prev, [key]: values }));
    } else {
      if (values) {
        console.log("Values", values);

        // const timevalue = moment(new Date(values)).format("YYYY-MM-DD");
        const timevalue = moment(new Date(values));
        setQueueFilter((prev) => ({ ...prev, [key]: timevalue }));
      } else {
        setQueueFilter((prev) => ({ ...prev, [key]: undefined }));
      }
    }
  };

  // const handleFilterShipmentDate = (values) => {
  //   console.log('SSorderStatus',moment(values));
  //   if (values === '' || values === undefined || values === null) {
  //     setFilterDot(false)
  //   }else{
  //     setFilterDot(true)
  //   }
  //   setQueueFilter((prev) => ({ ...prev, [key]: values }));
  // };

  const handleChange = (pagination, sorter, extra) => {
    console.log("tablechange", pagination, "sorter:", sorter, "extra:", extra);
    let field = extra.field;
    if (extra.order) {
      if (extra.order === "descend") {
        setSearchTable((prev) => ({ ...prev, order: "desc" }));
      } else {
        setSearchTable((prev) => ({ ...prev, order: "asc" }));
      }
    } else {
      setSearchTable((prev) => ({ ...prev, order: undefined }));
    }

    setSearchTable((prev) => ({
      ...prev,
      field: field,
    }));
    // searchShipment.setShipmentField(field);
    // searchShipment.setShipmentPage(pagination.current);
    // searchShipment.setShipmentSize(pagination.pageSize);
  };

  const handleChangePage = (page, size) => {
    setSearchTable((prev) => ({
      ...prev,
      page: page,
      size: size,
    }));
  };

  const handleChangePageRes = (page, size) => {
    setSearchTable((prev) => ({
      ...prev,
      page: page,
    }));
  };

  const handleChangeSize = (size) => {
    
    setSearchTable((prev) => ({
      ...prev,
      size: parseInt(size),
    }));
  };

  const handleApply = () => {
    setEvent((prev) => !prev);
    setSearchTable((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  const handleReset = () => {
    setQueueFilter({
      queueStatus: undefined,
      fromCreateDateIn: undefined,
      toCreateDateIn: undefined,
      fromCreateDateOut: undefined,
      toCreateDateOut: undefined,
    });
    setFilterDot(false);
    setEvent((prev) => !prev);
    setSearchTable((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  const onToggleFilter = () => {
    setFilterVisible((prev) => !prev);
  };

  return (
    <div className="d-flex flex-column w-100 h-100 p-3 justify-content-between">
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={isMobile ? [16, 24] : [16, 16]}>
          <Col span={24}>
            <SearchCardWithFilter
              handleSerchQueue={handleSerchQueue}
              onToggleFilter={onToggleFilter}
              filterDot={filterDot}
            />
            <div style={{ display: filterVisible ? undefined : "none" }}>
              <FilterTracking
                handleFilterShipment={handleFilterShipment}
                parkingStatus={parkingStatus}
                handleApply={handleApply}
                handleReset={handleReset}
                queueuFilter={queueuFilter}
              />
            </div>
          </Col>

          <Col span={24}>
            {/* test */}
            <ParkingList
              queueList={queueList}
              total={total}
              handleChange={handleChange}
              handleChangePage={handleChangePage}
              setEvent={setEvent}
              exportOrdersList={() => {}}
              isDesktop={isDesktop}
              searchTable={searchTable}
              handleChangePageRes={handleChangePageRes}
              handleChangeSize={handleChangeSize}
            />
          </Col>
        </Row>
      </div>
      {/* <Typography
        isBold
        className={`text-center w-100 ${isDesktop ? "pb-3" : "pb-1"}`}
        size={isDesktop ? "18px" : "14px"}
        color={COLORS.Gray}
      >
        <FormattedMessage
          id="textCustomerService"
          defaultMessage="Customer Service : 02-111-0099"
        />
      </Typography> */}
      {!isDesktop && (
        <div
          className={`d-flex align-items-center ${
            isDesktop ? "justify-content-start" : "justify-content-center"
          } px-4`}
          style={{
            height: 46,
            backgroundColor: COLORS.Primary,
            padding: "24px",
            width: "100vw",
            marginLeft: "-16px",
            // marginTop: "16px",
            marginBottom: "-16px",
          }}
        >
          <Typography size="12.5px" color={COLORS.White}>
            Powered by © RAPIDTECH Co., Ltd. (V 1.0)
          </Typography>
        </div>
      )}
    </div>
  );
};

export default CheckingStatusPark;
